//PCIB主页面
<template>
  <div id="pcib_main">
    <!-- 顶部我的账户栏信息 -->
    <ul class="top">
      <li>
        <span>{{userName}}</span>
        <span class="text">{{userCode}}</span>
        <span class="pointer">
          <router-link :to="{name: 'pcibOrderContacts'}">订单联系人管理</router-link>
        </span>
        <span class="pointer">
          <router-link :to="{name: 'pcibOrderAccount'}">修改本人信息</router-link>
        </span>
        <span class="pointer">
          <a href="/pcibOrder/help" target="_blank">帮助</a>
        </span>
        <span class="pointer" @click="secureEsc()">
          <a>安全退出</a>
        </span>
      </li>
    </ul>
    <!-- 返回按钮 -->
    <el-page-header
      title="返回订单列表"
      :content="routeCName"
      @back="backHome"
      v-show="routeCName !== '订单列表'"
    ></el-page-header>
    <router-view></router-view>
  </div>
</template>

<script>
import { post } from "@/util/http";
export default {
  name: "pcibOrderMain",
  beforeCreate() {
    let self = this;
    let token = sessionStorage.getItem("authToken");
    let user = JSON.parse(sessionStorage.getItem("user"));
    if (!token || user.is_superuser) {
      this.$router.push({
        name: "pcibOrderLogin"
      });
    }
  },
  created() {
    let self = this;
    let userInfo = JSON.parse(sessionStorage.getItem("user"));
    self.userName = userInfo.real_name;
    self.userCode = userInfo.crm_order_no;
  },
  data() {
    return {
      userName: "", //客户名称
      userCode: "" //客户编号
    };
  },
  computed: {
    routeCName() {
      return this.$route.meta.cName;
    }
  },
  methods: {
    // 返回订单列表
    backHome() {
      this.$router.push({
        name: "pcibOrderList"
      });
    },
    //安全退出
    secureEsc() {
      let self = this;
      post("user/logout/").then(
        res => {
          self.$notify({
            type: "success",
            message: "安全退出成功",
            offset: 70,
            duration: 1500
          });
          sessionStorage.removeItem("authToken");
          sessionStorage.removeItem("user");
          localStorage.removeItem("authToken");
          localStorage.removeItem("user");
          self.$router.push({
            name: "pcibOrderLogin"
          });
        },
        err => {
          self.$notify({
            type: "success",
            message: "安全退出成功",
            offset: 70,
            duration: 1500
          });
          sessionStorage.removeItem("authToken");
          sessionStorage.removeItem("user");
          localStorage.removeItem("authToken");
          localStorage.removeItem("user");
          self.$router.push({
            name: "pcibOrderLogin"
          });
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mirrors/auths/PcibOrderMain.vue